import PropTypes from 'prop-types';

const AlertDialog = ({ show, icon, title, children, actions, onClose }) => {
  if (!show) {
    return null;
  }

  return (
    <dialog open className="modal">
      <div className="modal-box">
        <div className="flex items-center gap-3 mb-4">
          {icon}
          <h3 className="font-bold text-lg">{title}</h3>
        </div>
        <div className="text-gray-600">{children}</div>
        <div className="modal-action">{actions}</div>
      </div>
      <div className="modal-backdrop bg-black/50" onClick={onClose}></div>
    </dialog>
  );
};

AlertDialog.propTypes = {
  show: PropTypes.bool.isRequired,
  icon: PropTypes.node,
  title: PropTypes.string.isRequired,
  children: PropTypes.node,
  actions: PropTypes.node,
  onClose: PropTypes.func,
};

export default AlertDialog;
